export enum SubscriptionStatus {
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    FROZEN = 'FROZEN',
}
